import StandaloneWeddingsBusinessCard from './StandaloneWeddingsBusinessCard';

export default StandaloneWeddingsBusinessCard;
